import React, { useState, useEffect, useContext } from 'react';
import { Tabs, Tab, Stack, FormControlLabel, Switch, Button, MenuItem, Drawer, IconButton } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import { useIsLargeUp, useIsMediumUp } from '../utils/responsive';

import Title from './ui/Title';
import { tokenContext } from './TokenProvider';
import { Box } from '@mui/system';

const standardTabs = [
	{ icon: <HomeIcon/>,	url:"/home"					},
	{	label: "Fixtures",	url:"/fixtures"			},
	{	label: "Table",			url:"/leaguetable"	},
	{	label: "Form",			url:"/form" 				},
	{	label: "Results",		url:"/results" 			},
	{ label: "History",		url:"/history"			},
	{ label: "Stats",			url:"/stats"				}
];

const loginTabs = [
	{	label: "Admin",			url:"/admin" 				},
];

const adminTabs = [
	{ label: "Enter Results",	url:"/adminresults"	},
	{ label: "Edit Fixtures",	url:"/adminfixtures"},
	{	label: "Seasons",				url:"/adminseasons"	},
	{	label: "Players",				url:"/adminplayers"	},
];

const Layout = ({darkMode,setDarkMode}) => {
	const isLargeUp=useIsLargeUp();
	const isMediumUp=useIsMediumUp();
	const tokenDebugMode=false;
  const {token,dropAdmin,invalidateToken}=useContext(tokenContext);
	const showTabs=(token!==null)?isLargeUp:isMediumUp;
	const tabs=[...standardTabs,...(token!==null?adminTabs:loginTabs)];
	const validTabUrls=tabs.map(tab => tab.url);

	// Menu support
	const [menuAnchorElement,setMenuAnchorElement]=useState(null);
	const menuOpen=Boolean(menuAnchorElement);
	const handleMenuButtonClick=(event)=>{
		setMenuAnchorElement(event.currentTarget);
	}
	const handleClose=()=>{
		setMenuAnchorElement(null);
	}
	const menuItemsJsx = tabs.map(tab =>
		<MenuItem key={tab.url} component={Link} to={tab.url} onClick={handleClose}>{tab.icon?tab.icon:tab.label}</MenuItem>
	);

	// Tabs support
	const tabsJsx = tabs.map(tab => 
		<Tab key={tab.url} label={tab.label} icon={tab.icon} value={tab.url} component={Link} to={tab.url} />
	);
	var path=useLocation().pathname;
	if (!validTabUrls.includes(path))
		path=validTabUrls[0];
	const [tabValue, setTabValue] = useState(path);
	// Ensuring the state gets updated whenever path changes makes sure
	// tab state gets updates when back/forward pressed.
	useEffect(() => {
		setTabValue(path);
	},[path]);

	if (token!==null && tabValue==="/admin")
		setTabValue(adminTabs[0].url);
	if (token===null && adminTabs.map((t)=>t.url).includes(tabValue))
		setTabValue(loginTabs[0].url);

	const darkModeSwitch=<FormControlLabel control={<Switch checked={darkMode} onChange={setDarkMode} color='secondary' />} label="Dark Mode" />;
	const menuButton=(!showTabs)?<IconButton variant="contained" color="inherit" size="x-large" edge="end" sx={{ml:1,mr:0}} onClick={handleMenuButtonClick}><MenuIcon/></IconButton>
																:null;
	return(
		<div>

		<Stack spacing={4} marginTop={(!showTabs)?"50px":null} marginBottom="50px">
			<Stack spacing={0}>
				<Stack direction="row" spacing={0}>
					
				<Title menuButton={menuButton}>
					{showTabs && token!==null && <Button variant="contained" onClick={dropAdmin}>Drop Admin</Button>}
					{token!==null && tokenDebugMode && <Button variant="contained" onClick={invalidateToken}>Invalidate Token</Button>}
					{showTabs && darkModeSwitch}
				</Title>
				</Stack>
				{showTabs && 
					<Stack direction="row">
						<Tabs value={tabValue} onChange={(_,value) => setTabValue(value)}>
							{tabsJsx}
						</Tabs>
					</Stack>
				}
			</Stack>
			<Box marginTop="100px">
				<Outlet/>
			</Box>
		</Stack>
			{!showTabs &&
				<Drawer open={menuOpen} onClose={handleClose} disableScrollLock={true}>
					{menuItemsJsx}
					{darkModeSwitch}
					{token!==null && <Button variant="contained" onClick={dropAdmin}>Drop Admin</Button>}
				</Drawer>
			}
		</div>
	);
}

export default Layout;